import React, { Component } from "react";
import { Container } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSort
} from "@fortawesome/free-solid-svg-icons";
  import { withRouter } from "react-router-dom";
  import { connect } from 'react-redux';
import Calender from '../../components/common/calender';
import DashMenuItem from "../../components/Admin/dashMenuItem";
import PagePath from "../../components/common/pagePath";
import HistoRow from "../../components/Admin/histoRow";

class Histo extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      
     }
}


  render() {
    const cuurentUser = this.props.currentUser

    return (
  
<Container>
    <div className="pt-4 pb-5">
         <PagePath pages={['Acceuil', 'Historique']} />
         <div className="histo__header d-flex justify-content-between align-items-center col-9 container mx-0  mt-5">
                <div className="profile__infos d-flex align-items-center">
                      <img src="/imgs/dash/histo_fill.svg" className='histo__icon' alt="" />
                      <h3 className='profile__name'>Historique</h3>
                </div>
                <div className="col-6 pr-0 mr-0">
                   <Calender returnBool={true}/>
                </div>
                
         </div>
         <hr className="col-9 mt-3 d-flex flex-start ml-3 "/>
         <div className="dash__menu d-flex justify-content-between col-7 container mt-4 mx-0">
              
              <DashMenuItem icon="/imgs/dash/echange.svg" txt="Ventes/Achats" size="75px" />
              <DashMenuItem icon="/imgs/dash/remb.svg" txt="Remboursements" size="75px" />
              <DashMenuItem icon="/imgs/dash/pena.svg" txt="Pénalités" size="75px"/>
              <DashMenuItem icon="/imgs/dash/archv.svg" txt="Archive" size="75px"/>
              <DashMenuItem icon="/imgs/dash/trash.svg" txt="Corbeille" size="75px"/>
        </div>
        <hr className="col-9 mt-3 d-flex flex-start ml-3 "/>
        <div className="historique__container container mx-0 mt-5 mb-4 ">
            <div className="histo__filter d-flex">
              <div className="histo__filter col-3 text-center"></div>
              <div className="histo__filter col-3 text-center">
                 <input className="histo__dateInput  histo__mb" type="datetime-local" id="birthdaytime" name="birthdaytime"></input>
              </div>
              <div className="histo__filter col-1  d-flex justify-content-center mnt" >
                <button className="sort__mont d-flex align-items-center mnt  histo__mb" ><FontAwesomeIcon className="mr-2 " icon={faSort}/><span>Montant</span></button>
              </div>
              <div className="histo__filter col-1 text-center">
            
                  <select className="select_dev histo__filter__txt " >
                  <option value="" disabled selected hidden>Devise</option>
                    <option>usd</option>
                    <option>eur</option>
                  </select>
          
              </div>
              <div className="histo__filter col-2 text-center">
                  <select className="select_dev histo__filter__txt " >
                    <option value="" disabled selected hidden>Mode de paiement</option>
                    <option>Paysera</option>
                    <option>Paypal</option>
                  </select>
              </div>
              <div className="histo__filter col-2 text-center"><span className="histo__filter__txt">Actions</span></div>
            </div>
        </div>
        <HistoRow icon="/imgs/dash/echange__gr.svg" name="Annonce N° 002019122443" date="17/10/2020" time="10:21" mont="+ 50" devise="EUR" mode="Paypal"/>
        <HistoRow icon="/imgs/dash/pena__sm.svg" name="Pénalité (Annonce N° 002019)" date="17/10/2020" time="10:21" mont="- 50" devise="USD" mode="Paysera"/>
        <HistoRow icon="/imgs/dash/return__sm.svg" name="Remboursement " date="17/10/2020" time="10:21" mont="+ 2000" devise="DZD" mode="Dahabia"/>
        <HistoRow icon="/imgs/dash/echange__red.svg" name="Annonce N° 002019122443" date="17/10/2020" time="10:21" mont="- 15000" devise="EUR" mode="Paypal"/>
        <hr className="mt-2 mx-3"/>
        <div className="printBtn d-flex justify-content-center">
           <button className="histo__print">
             <img src="/imgs/dash/print.svg" className="print__icon" alt="" />
             Imprimer / Exporter
           </button>
        </div>
        
        
    </div>
    </Container>
    );
  }
}


function mapStateToProps(state) {
  return {
    /*
    isOpenAddanc: state.counterApp.isOpenAddanc,
    */
  }
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(Histo));